import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("ProductManagement/api/CategoriesQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("ProductManagement/api/Categories", model).then(() => {
        dispatch("fetch");
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "ProductManagement/api/Categories",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("ProductManagement/api/Categories", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
